import { UserCard } from 'types/interfaces/user/UserCard';

import { httpClient } from './httpClient';

export enum ActionTypes {
  Like = 1,
}

export enum SourceTypes {
  Finder = 1,
  UserProfile = 2,
  Generic = 3,
  Discovery = 4,
  Likes = 5,
  Visits = 7,
  Video = 8,
}

export type LikePayload = {
  receiverId: number;
  actionType?: ActionTypes;
  sourceType?: SourceTypes;
};

interface LikeListItem {
  action_type: number;
  created_at: string;
  id: number;
  is_new: boolean;
  is_read: boolean;
  receiver: UserCard;
  receiver_id: number;
  sender: UserCard;
  sender_id: number;
  source_type: number;
  updated_at: string;
}

export interface LikesListResponse {
  next: string | null;
  likes: LikeListItem[];
  is_new_count: number;
}

export interface MyLikesPopupResponse {
  likes: UserCard[];
}

export const SympathiesApi = {
  async like(payload: LikePayload) {
    const {
      receiverId,
      sourceType = SourceTypes.Finder,
      actionType = ActionTypes.Like,
    } = payload;

    await httpClient.post('/sympathies', {
      receiver_id: receiverId,
      source_type: sourceType,
      action_type: actionType,
    });
  },

  async fetchMyLikes(url?: string) {
    const { data } = await httpClient.get(url ?? '/sympathies/my-likes');

    return data;
  },

  async fetchLikes(url?: string) {
    const { data } = await httpClient.get<LikesListResponse>(
      url ?? '/sympathies/likes'
    );

    return data;
  },

  async fetchMathesLikes(url?: string) {
    const { data } = await httpClient.get<LikesListResponse>(
      url ?? '/sympathies/mutual-likes'
    );

    return data;
  },

  async fetchMyLikesPopup() {
    const { data } = await httpClient.get<MyLikesPopupResponse>(
      '/sympathies/popup'
    );

    return data;
  },
};
